export default __webpack_public_path__ + "static/media/img-register.dc7a67a8.png";